import { useState } from "react";
import { Radio, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export function WebhookSelfTest({ onDone }) {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.whatsappWebhookSelftest();
      setRes(r);
      (r.ok ? toast.success : toast.error)(r.hint || r.error || (r.ok ? "Webhook OK" : "Webhook KO"));
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Test non riuscito");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2" data-testid="webhook-selftest">
      <Button size="sm" variant="secondary" className="gap-1.5" disabled={busy} onClick={run} data-testid="webhook-selftest-button">
        <Radio className={`h-3.5 w-3.5 ${busy ? "animate-pulse" : ""}`} /> Invia evento di test firmato
      </Button>
      {res && (
        <div className={`rounded-md border p-2 text-[11px] space-y-0.5 ${res.ok ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" : "border-red-500/30 bg-red-500/10 text-red-300"}`} data-testid="webhook-selftest-result">
          <div className="flex items-center gap-1.5 font-semibold">{res.ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <XCircle className="h-3.5 w-3.5" />} {res.ok ? "Evento accettato" : "Evento rifiutato"}{res.http_status ? ` · HTTP ${res.http_status}` : ""}</div>
          <div className="break-all text-muted-foreground">→ {res.target}</div>
          <div>{res.hint || res.error}</div>
        </div>
      )}
    </div>
  );
}
